import Duck from 'extensible-duck';
import toast from 'simple-pure-toast';
import { get } from '../../utils/request';
import {
  convertDateFinish,
  convertDateInit,
  fechaActual,
  fechaInicial,
  handlerRequestErrors,
  msjCommon,
  statusesCommon,
  typesCommon,
  typeToast
} from '../../utils/helpers';

const initialState = {
  message: '',
  status: '',
  loading: false,
  resumenIndicadoresVentas: {
    metaPrimaMensual: 0,
    totalPrimaMensual: 0,
    porcentajeAvancePrimaMensual: 0,
    metaPolizasMensual: 0,
    totalPolizasMensual: 0,
    porcentajeAvancePolizasMensual: 0
  },
  resumenIndicadoresAccionDeep: {
    totalAccionesDeep: 0,
    cantidadDeepCerrado: 0,
    cantidadDeepAprobado: 0
  },
  listadoQuickDeep: [],
  seguimientoAcciones: [],
  historialAcciones: []
};

const getInitialState = ({ statuses }) => ({
  ...initialState,
  status: statuses.NEW
});

const setCatch = (error, dispatch, types) => {
  const { message } = handlerRequestErrors(error);
  dispatch({ type: types.LOADING_EFFECT, loading: false });
  dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
};

export default new Duck({
  namespace: 'converti',
  store: 'seguimiento',
  consts: {
    statuses: [
      ...statusesCommon
    ]
  },
  types: [
    ...typesCommon,
    'FETCH_FULLFILLED_LISTADO_QUICK_DEEP',
    'FETCH_SEGUIMIENTO_ACCIONES',
    'FETCH_HISTORIAL_ACCIONES',
    'RESET_SEGUIMIENTO_DUCK',
    'FETCH_RESUMEN_INDICADORES_VENTAS',
    'FETCH_RESUMEN_INDICADORES_ACCIONES_DEEP'
  ],
  initialState: getInitialState,
  reducer: (state, action, { types, statuses }) => {
    switch (action.type) {
      case types.CREATOR_FAILD:
        toast.error(msjCommon('fallo'), { description: action.payload.message, position: 'bottomRight' });
        return { ...state, status: statuses.ERROR };

      case types.LOADING_EFFECT:
        return {
          ...state,
          loading: action.loading
        };

      case types.TOAST:
        typeToast(action.data.toast, action.data.payload.message);
        return { ...state, loading: action.data.loading };

      case types.FETCH_FULLFILLED_LISTADO_QUICK_DEEP:
        return {
          ...state,
          listadoQuickDeep: action.payload
        };

      case types.FETCH_SEGUIMIENTO_ACCIONES:
        return {
          ...state,
          seguimientoAcciones: action.payload
        };

      case types.FETCH_HISTORIAL_ACCIONES:
        return {
          ...state,
          historialAcciones: action.payload
        };

      case types.FETCH_RESUMEN_INDICADORES_VENTAS:
        return { ...state, resumenIndicadoresVentas: action.payload };

      case types.FETCH_RESUMEN_INDICADORES_ACCIONES_DEEP:
        return { ...state, resumenIndicadoresAccionDeep: action.payload };

      case types.RESET_SEGUIMIENTO_DUCK:
        return getInitialState({ statuses });

      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state
  },
  creators: ({ types }) => ({
    getListadoQuickDeep: (requestPayload = {}) => async (dispatch, getState) => {
      try {
        const { auth: { user: { userId } } } = getState();
        dispatch({ type: types.LOADING_EFFECT, loading: true });

        const json = {
          queryStringParameters: {
            idUsuario: userId,
            idAsignado: requestPayload?.idAsignado || null,
            fechaInicio: convertDateInit(requestPayload.fechaInicio || fechaInicial),
            fechaFin: convertDateFinish(requestPayload.fechaFin || fechaActual)
          }
        };

        const { payload } = await get('/subordinados/cantidad-acciones', json);

        dispatch({ type: types.FETCH_FULLFILLED_LISTADO_QUICK_DEEP, payload });

        dispatch({ type: types.LOADING_EFFECT, loading: false });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loading: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    getSeguimientoAcciones: (requestPayload = {}) => async (dispatch, getState) => {
      try {
        const { auth: { user: { userId } } } = getState();
        dispatch({ type: types.LOADING_EFFECT, loading: true });

        const json = {
          queryStringParameters: {
            idUsuario: userId,
            idCreador: requestPayload?.idCreador || null,
            fechaInicio: convertDateInit(requestPayload.fechaInicio || fechaInicial),
            fechaFin: convertDateFinish(requestPayload.fechaFin || fechaActual)
          }
        };

        const { payload } = await get('/subordinados/seguimiento-acciones', json);

        dispatch({ type: types.FETCH_SEGUIMIENTO_ACCIONES, payload });

        dispatch({ type: types.LOADING_EFFECT, loading: false });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loading: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    getHistorialAcciones: (requestPayload = {}) => async (dispatch, getState) => {
      try {
        const { auth: { user: { userId } } } = getState();
        dispatch({ type: types.LOADING_EFFECT, loading: true });

        const json = {
          queryStringParameters: {
            idUsuario: userId,
            idCreador: requestPayload?.idCreador || null,
            idAsignado: requestPayload?.idAsignado || null,
            fechaInicio: convertDateInit(requestPayload.fechaInicio || fechaInicial),
            fechaFin: convertDateFinish(requestPayload.fechaFin || fechaActual)
          }
        };

        const { payload } = await get('/subordinados/historial-acciones', json);

        dispatch({ type: types.FETCH_HISTORIAL_ACCIONES, payload });

        dispatch({ type: types.LOADING_EFFECT, loading: false });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loading: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    resetSeguimientoDuck: () => async (dispatch) => {
      dispatch({ type: types.RESET_SEGUIMIENTO_DUCK });
    },

    getResumenindicadoresVentas: () => async (dispatch, getState) => {
      try {
        const { auth: { user: { codigoSap } } } = getState();
        const path = `/V1/indicadores/ventas/usuarios/${codigoSap}/resumen`;
        const { payload } = await get(path, {}, process.env.REACT_APP_CONVERTI_API_NAME);
        dispatch({ type: types.FETCH_RESUMEN_INDICADORES_VENTAS, payload });
      } catch (e) {
        setCatch(e, dispatch, types);
      }
    },
    getResumenindicadoresAccionesDeep: () => async (dispatch, getState) => {
      try {
        const { auth: { user: { codigoSap } } } = getState();
        const { payload } = await get(`/indicadores/acciones-deep/usuarios/${codigoSap}/resumen`);
        dispatch({ type: types.FETCH_RESUMEN_INDICADORES_ACCIONES_DEEP, payload });
      } catch (e) {
        setCatch(e, dispatch, types);
      }
    }
  })
});
